
export default {
  props: {
    pointer: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    }
  }
}
